'use client';

import { c as _c } from "react/compiler-runtime";
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import Image from 'next/image';
import { useMemo } from 'react';
import { BalanceTransferCalculatorError } from './Error';
import { formatCurrency } from './utils';
import './bt-calculator.css';
import { useShallow } from 'zustand/shallow';
import { useBTCalculatorStore } from './Form/calculatorStore';
export const GraphVisualization = () => {
  const $ = _c(5);
  const {
    balanceTransferFee: balanceTransferFee_0,
    interestWithExistingDebt: interestWithExistingDebt_0,
    savings: savings_0
  } = useBTCalculatorStore(useShallow(_temp));
  const hasError = savings_0 <= 0;
  let t0;
  if ($[0] !== balanceTransferFee_0 || $[1] !== hasError || $[2] !== interestWithExistingDebt_0 || $[3] !== savings_0) {
    t0 = hasError ? <BalanceTransferCalculatorError /> : <Box sx={{
      display: "flex",
      flexDirection: "column",
      marginX: "auto",
      justifyContent: "center",
      gap: 3
    }}><Grid container={true} size={12}><Grid size={{
          xs: 3,
          sm: 3.5
        }} offset={{
          xs: 1.4,
          sm: 0.25
        }} sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end"
        }}><Typography variant="textSmallBold" sx={{
            fontSize: {
              xs: "10px",
              sm: "14px"
            },
            color: "reds.dark",
            textAlign: "center"
          }}>Total interest without transfer:</Typography><Typography variant="textSmallBold" sx={{
            fontSize: {
              sm: "18px"
            },
            color: "reds.main",
            textAlign: "center"
          }}>{formatCurrency({
              amount: interestWithExistingDebt_0
            })}</Typography></Grid><Grid offset={{
          xs: 2,
          sm: 1.75
        }} size={3} sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}><Box sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: {
              xs: "75px",
              sm: "101px"
            },
            width: {
              xs: "60px",
              sm: "81px"
            }
          }}><Image src="https://cdns3.nerdwallet.com/cc-shopping-client/bt-calculator/pot_of_gold_with_piggy.png" alt="" width={80} height={100} style={{
              position: "relative",
              zIndex: 3,
              bottom: "-35px",
              height: "100%",
              width: "100%"
            }} /></Box></Grid><Grid size={{
          xs: 2,
          sm: 3
        }} sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          paddingLeft: {
            xs: "11px",
            md: 1
          }
        }}><Typography variant="textSmallBold" sx={{
            fontSize: {
              sm: "18px"
            },
            color: "greens.darkest"
          }}>Savings:</Typography><Typography variant="textBold" sx={{
            fontSize: {
              sm: "22px"
            },
            color: "greens.main"
          }}>{formatCurrency({
              amount: savings_0
            })}</Typography></Grid></Grid><Grid container={true} size={12} sx={{
        justifyContent: "center"
      }}><Grid size={3} offset={{
          xs: 0.75,
          sm: 0
        }} sx={{
          zIndex: 2,
          display: "flex",
          justifyContent: "center"
        }}><Box className="debt-cylinder" sx={{
            outline: "0.4rem solid white",
            justifySelf: "center",
            width: {
              xs: "65px",
              sm: "88px"
            },
            height: {
              xs: "200px",
              sm: "260px"
            },
            borderRadius: "100% / 12%",
            background: "radial-gradient(50% 8% at 50% 5%, #DE2828 100%, #0000 105%), #FF9090"
          }} /></Grid><Grid size={2} sx={{
          marginLeft: {
            xs: "-15px",
            sm: "-5px"
          },
          marginRight: {
            xs: "15px",
            sm: 1
          },
          paddingY: 3
        }}><Box sx={{
            borderTop: "2px dashed",
            borderColor: "neutral.lighter",
            width: "100px"
          }} /><Box sx={{
            borderTop: "2px dashed",
            borderColor: "neutral.lighter",
            width: "100px",
            position: "relative",
            transition: "top 1s ease-in-out"
          }} style={{
            top: `${savings_0 / interestWithExistingDebt_0 * 100}%`
          }} /><Box sx={{
            borderTop: "2px dashed",
            borderColor: "neutral.lighter",
            width: "100px",
            position: "relative",
            top: "100%"
          }} /></Grid><Grid size={3}><Box sx={{
            height: {
              xs: "200px",
              sm: "260px"
            },
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}><Box className="savings-cylinder" style={{
              height: `${savings_0 / interestWithExistingDebt_0 * 100}%`
            }} sx={{
              width: {
                xs: "79px",
                sm: "106px"
              },
              borderRadius: "100% / 22px",
              background: "radial-gradient(50% 20px at 50% 10px, #40AD87 100%, #0000 105%),  #81D6B8",
              outline: "0.4rem solid white",
              zIndex: 2,
              transition: "height 1s ease-in-out",
              minHeight: "10%"
            }} /><Box className="balance-transfer-cylinder" style={{
              height: `${balanceTransferFee_0 / interestWithExistingDebt_0 * 100}%`
            }} sx={{
              outline: "0.4rem solid white",
              width: {
                xs: "65px",
                sm: "88px"
              },
              borderBottomLeftRadius: "100% 22px",
              borderBottomRightRadius: "100% 22px",
              bgcolor: "blues.lighter",
              zIndex: 1,
              transition: "height 1s ease-in-out",
              maxHeight: "90%"
            }} /></Box></Grid><Grid size={{
          xs: 2,
          sm: 3
        }} sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          paddingLeft: {
            xs: "11px",
            md: 1
          }
        }}><Typography variant="textSmallBold" sx={{
            fontSize: {
              xs: "10px",
              sm: "14px"
            },
            color: "blues.darkest"
          }}>Balance Transfer Fee:</Typography><Typography variant="textSmallBold" sx={{
            fontSize: {
              sm: "18px"
            },
            color: "blues.main"
          }}>{formatCurrency({
              amount: balanceTransferFee_0
            })}</Typography></Grid></Grid><Grid container={true} size={12} sx={{
        alignItems: "center"
      }} spacing={3}><Grid size={4} offset={{
          xs: 1.1,
          sm: 0.1
        }} sx={{
          display: {
            xs: "flex",
            sm: "block"
          }
        }}><Typography variant="textSmallBold" sx={{
            fontSize: {
              xs: "10px",
              sm: "14px"
            },
            textAlign: "center",
            whiteSpace: {
              sm: "nowrap"
            }
          }}>Existing Card Debt</Typography></Grid><Grid size={5} offset={0.5} sx={{
          paddingLeft: 1,
          display: {
            xs: "flex",
            sm: "block"
          },
          whiteSpace: "nowrap"
        }}><Typography variant="textSmallBold" sx={{
            fontSize: {
              xs: "10px",
              sm: "14px"
            },
            textAlign: "center"
          }}>With Balance Transfer</Typography></Grid></Grid></Box>;
    $[0] = balanceTransferFee_0;
    $[1] = hasError;
    $[2] = interestWithExistingDebt_0;
    $[3] = savings_0;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  return t0;
};
function _temp(t0) {
  const {
    results: t1
  } = t0;
  const {
    balanceTransferFee,
    interestWithExistingDebt,
    savings
  } = t1;
  return {
    balanceTransferFee,
    interestWithExistingDebt,
    savings
  };
}